module.exports = __webpack_public_path__ + "static/media/man (1).bd80794f.png";